export function GoogleBusinessItem() {
    function render(business: Record<string, any>, index: number) {
        return /*html*/`
        <label for="gReviews_single_business_${index}"
            class="cursor-pointer px-4 py-3 gap-4 bg-white rounded-lg border border-gray-200 justify-between sm:items-center flex flex-col sm:flex-row w-full transition-all dark:bg-neutral-900 dark:border-neutral-700 hover:bg-blue-50 dark:hover:bg-neutral-800 has-[:checked]:bg-blue-50 dark:has-[:checked]:bg-neutral-800 dark:has-[:checked]:border-blue-600">
            <input type="radio" id="gReviews_single_business_${index}"
                class="hidden bg-transparent border-gray-200 text-indigo-600 focus:ring-white focus:ring-offset-0 dark:text-indigo-500 dark:border-neutral-700 dark:focus:ring-neutral-900" name="selected-business" value="${business.place_id}" ${index == 0 ? `checked` : ''}>
            <div>
                <h3 class="line-clamp-1 text-gray-900 text-base font-semibold dark:text-white">${business.name}</h3>
                ${business.full_address != null ? `<p class="line-clamp-1 text-gray-600 text-xs font-normal dark:text-neutral-500">${business.full_address}</p>` : ''}
            </div>
            <div>
                <div class="flex items-center gap-1">
                <span class="text-gray-900 text-sm font-medium dark:text-white">${business.reviews != null ? business.reviews : 0}</span>
                <span class="text-gray-900 text-sm font-medium dark:text-white">Reviews</span>
                <span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path
                        d="M8.00016 12.4983L11.2334 14.5445C11.8255 14.9195 12.5501 14.3651 12.3942 13.664L11.5372 9.81627L14.3965 7.22392C14.9185 6.7511 14.638 5.85438 13.9524 5.79731L10.1894 5.46308L8.71693 1.82727C8.45204 1.16695 7.54829 1.16695 7.2834 1.82727L5.81091 5.45493L2.04789 5.78916C1.36229 5.84623 1.08182 6.74295 1.60381 7.21577L4.46308 9.80812L3.60608 13.6559C3.45026 14.357 4.17482 14.9113 4.76693 14.5363L8.00016 12.4983Z"
                        fill="#EAB308"></path>
                    </svg>
                </span>
                </div>
            </div>
        </label>
        `;
    }

    return {
        render
    };
}